import { forwardRef } from "react";
import { Container } from "@mui/material";

// single-source-of-truth page container.
//
// Replaces the ~10 inline `<Container maxWidth={false} sx={{ maxWidth: "87.5rem" }}>`
// usages across pages. Variants:
//   - default : standard editor / dashboard width (1400px)
//   - narrow  : login / 404 / status pages (720px)
//   - wide    : full-bleed for topology / fabric views
//
// The component forwards refs (editors scroll into their root) and supports
// arbitrary `sx` overrides.

const WIDTHS = {
  default: "87.5rem",
  narrow: "45rem",
  wide: "100rem",
};

const PageContainer = forwardRef(function PageContainer(
  { variant = "default", sx, children, disableGutters = false, ...rest },
  ref,
) {
  const maxWidth = WIDTHS[variant] || WIDTHS.default;

  return (
    <Container
      ref={ref}
      maxWidth={false}
      disableGutters={disableGutters}
      sx={{
        width: "100%",
        maxWidth,
        mx: "auto",
        px: disableGutters ? 0 : { xs: 2, md: 3 },
        pb: { xs: 4, md: 5 },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Container>
  );
});

export default PageContainer;
